
import React from 'react';

import { User } from "shared/services/user.service";
import { Route, Redirect  } from 'react-router-dom'

export const LoginRouter = ({component: Component,recurso = '', ...rest }) => {
    const user = new User();

    if(user.isAuthenticated())
      return <Redirect to={'/dashboard'}/>

    return (
      <Route {...rest} render={props => (
        <Component {...props} />
      )} />
  );
}
